import { useRef } from "react";

// STYLES
import * as Style from "./TextEditorStyle";

// LIBRARIES
import { Editor } from "@tinymce/tinymce-react";

// MISC
import { IProps } from "./TextEditorModel";

// ASSETS

// REDUX

// COMPONENTS

const TextEditor = (props: IProps) => {
  // PROPS
  const { label = "", height = 184, value, setValue } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const editorRef = useRef(null);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.TextEditorContainer>
      <Style.LabelContainer labelColor={""}>{label}</Style.LabelContainer>
      <Style.Container>
        <Editor
          apiKey="0ehupqsg01w020n3uj3f8jb95gf2zooh6yc4jitfshxl4dc5"
          onInit={(evt, editor) => (editorRef.current = editor)}
          onEditorChange={() => setValue(editorRef.current.getContent())}
          value={value}
          init={{
            height: height,
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "help",
              "wordcount",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic forecolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              //eslint-disable-next-line
              "body { background-color: #EAE8E8; }" + "border: 5px solid red;",
          }}
        />
      </Style.Container>
    </Style.TextEditorContainer>
  );
};

export default TextEditor;
